export default /* glsl */`
void main(void) {
    gl_Position = getPosition();
`;
